var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlockContainer',[_c('div',{staticClass:"flex flex-wrap p-4"},_vm._l((_vm.orderedBlogPosts),function(item,i){return _c('BlockWideThumbnail',_vm._b({key:i,on:{"click":function($event){return _vm.$router.push({ name: 'BlogItem', params: { slug: item.slug } })}}},'BlockWideThumbnail',item,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }